import { LitElement, css, html } from "lit";
import { defineChromeElement } from "../../chrome/ChromeElement";
import { chromeControlStyles } from "../../chrome/chromeStyles";
import type { GameHeaderPort } from "./GameHeaderPort";

/** `HeaderLayer.prefab`: a 100-tall strip pinned to the top with the clock (left 20) and the title (left 158.4); ×m in mobile landscape (its ResponsiveLandscapeHeightCompensator, max 1.5 — the chrome root's `--slot-landscape-m`, the bar's top-group multiplier). */
const HEADER = { height: 100, clock: { width: 124.2, height: 50.4, left: 20 }, title: { width: 309.5, height: 52.4, left: 158.4 } } as const;

export const GAME_HEADER_TAG = "slot-game-header";

/** `<slot-game-header>`: the top strip — the wall clock and the game title. Above the modals, as before. */
export class GameHeaderElement extends LitElement implements GameHeaderPort {
  public static override properties = {
    shown: { type: Boolean, reflect: true },
    time: { state: true },
    heading: { state: true },
  };

  public declare shown: boolean;
  private declare time: string;
  private declare heading: string;

  public constructor() {
    super();
    this.shown = true;
    this.time = "";
    this.heading = "";
  }

  public static override styles = [
    chromeControlStyles,
    css`
      :host { --m: var(--slot-landscape-m, 1); display: block; position: absolute; left: 0; top: 0; width: calc(100% / var(--m)); height: ${HEADER.height}px; transform: scale(var(--m)); transform-origin: top left; color: #fff; font-size: 25px; font-weight: 500; pointer-events: none; }
      :host(:not([shown])) { display: none; }
      .row { position: absolute; top: 50%; transform: translateY(-50%); display: flex; align-items: center; line-height: 1.1; }
      .clock { left: ${HEADER.clock.left}px; width: ${HEADER.clock.width}px; justify-content: center; text-align: center; }
      .title { left: ${HEADER.title.left}px; width: ${HEADER.title.width}px; white-space: pre-wrap; }
    `,
  ];

  public setTime(text: string): void {
    this.time = text;
  }

  public setTitle(text: string): void {
    this.heading = text;
  }

  public setVisible(visible: boolean): void {
    this.shown = visible;
  }

  protected override render() {
    return html`<div class="row clock outline" data-part="time">${this.time}</div><div class="row title outline" data-part="title">${this.heading}</div>`;
  }
}

export function defineGameHeaderElement(): void {
  defineChromeElement(GAME_HEADER_TAG, GameHeaderElement);
}
